export const services = [
  {
    title: 'Social Media Marketing',
    href: '/services/social-media-marketing'
  },
  {
    title: 'Web Designing',
    href: '/services/web-designing'
  },
  {
    title: 'Local SEO',
    href: '/services/local-seo'
  },
  {
    title: 'SEO',
    href: '/services/seo'
  },
  {
    title: 'PPC',
    href: '/services/ppc'
  },
  {
    title: 'GMB',
    href: '/services/gmb'
  }
]

export const navLinks = [
  {
    title: 'Home',
    href: '/',
    bgColor: ''
  },
  {
    title: 'Services',
    href: '/services',
    services,
    bgColor: 'bg-accent'
  },
  {
    title: 'Packages',
    href: '/packages',
    bgColor: 'bg-accent'
  },
  {
    title: 'Reviews',
    href: '/review',
    bgColor: 'bg-accent'
  },
  {
    title: 'Industries',
    href: '/industries',
    bgColor: 'bg-accent'
  },
  {
    title: 'About Us',
    href: '/about-us',
    bgColor: 'bg-slate-700'
  },
  {
    title: 'Contact Us',
    href: '/contact-us',
    bgColor: 'bg-accent'
  },
  {
    title: 'Privacy Policy',
    href: '/privacy-policy',
    bgColor: 'bg-accent',
    showInNavbar: false
  },
  {
    title: 'Terms and Condition',
    href: '/terms-and-condition',
    bgColor: 'bg-accent',
    showInNavbar: false
  },
  {
    title: 'Refund Policy',
    href: '/refund-policy',
    bgColor: 'bg-accent',
    showInNavbar: false
  }
]
